import { render, staticRenderFns } from "./payconfig.vue?vue&type=template&id=53616d74"
import script from "./payconfig.vue?vue&type=script&lang=js"
export * from "./payconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports